// Cores do realce A/B dos conflitos. Num modulo a parte, sem dependencias,
// para o realce no 3D (clashHighlight) e o Coloring dos topicos BCF
// (clashBcf) usarem exactamente as mesmas.

/** Ciano para o conjunto A. Escolhido por nao colidir com nada do que ja
 *  ha: seleccao e ambar (#f59e0b), pre-seleccao ambar claro (#fbbf24),
 *  fantasma cinzento (#9ca3af), transparencia cinzento claro (#cbd5e1) e
 *  o Comparar IFC usa verde / vermelho / ambar. */
export const CLASH_COLOR_A = '#22d3ee'
/** Magenta para o conjunto B. Ciano contra magenta le-se nas tres formas
 *  comuns de daltonismo (o par nao depende do eixo vermelho-verde) e
 *  destaca-se de qualquer paleta de classes IFC, que anda pelos tons
 *  terra e azul-acinzentado. */
export const CLASH_COLOR_B = '#e879f9'

/** A cor no formato do BCF (RRGGBB, sem cardinal, maiusculas). */
export function corBcf(hex: string): string {
  return hex.replace(/^#/, '').toUpperCase()
}
